// extracted by mini-css-extract-plugin
export default {"section":"Es-z","inSectionButton":"Fs-z","addressCard":"Gs-z","disabled":"Hs-z","cautionBox":"Is-z","failureBox":"Js-z","fade-out":"Ks-z","successBox":"Ls-z"};